/**------------- Back Button constants -------------**/

/*  General  */
export const BACK_BUTTON_CLASS_NAME = "back-button";

/*  Label  */
export const BACK_BUTTON_LABEL = "Indietro";
